// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.\\------packages-foundation-account-ui-base-src-components-user-info-panel-username-input-index-module__input-o_07Nd input {
  padding: 6px 0 6px 16px !important;
}

.\\------packages-foundation-account-ui-base-src-components-user-info-panel-username-input-index-module__input-o_07Nd .semi-input-prefix {
  border-radius: 8px 0 0 8px;
  width: 42px;
  height: 100%;
  margin: 0;
  padding: 0 16px;
}

.\\------packages-foundation-account-ui-base-src-components-user-info-panel-username-input-index-module__input-o_07Nd .semi-input-suffix > span {
  padding-right: 16px;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}

.\\------packages-foundation-account-ui-base-src-components-user-info-panel-username-input-index-module__input-o_07Nd .semi-input-suffix > span > span:first-child {
  margin-right: 4px;
}

.\\------packages-foundation-account-ui-base-src-components-user-info-panel-username-input-index-module__input-o_07Nd .semi-input-suffix > span > span:last-child {
  margin-left: 4px;
}

.\\------packages-foundation-account-ui-base-src-components-user-info-panel-username-input-index-module__input-o_07Nd.\\------packages-foundation-account-ui-base-src-components-user-info-panel-username-input-index-module__page-GDfBX3 {
  border-color: rgba(29, 28, 35, .16);
}

.\\------packages-foundation-account-ui-base-src-components-user-info-panel-username-input-index-module__input-o_07Nd.\\------packages-foundation-account-ui-base-src-components-user-info-panel-username-input-index-module__modal-zzCLN1 {
  border-color: rgba(29, 28, 35, .08);
}

.\\------packages-foundation-account-ui-base-src-components-user-info-panel-username-input-index-module__input-o_07Nd:hover {
  border-color: var(--semi-color-focus-border);
}

.\\------packages-foundation-account-ui-base-src-components-user-info-panel-username-input-index-module__input-o_07Nd:focus-within {
  border-color: var(--semi-color-focus-border);
}

.\\------packages-foundation-account-ui-base-src-components-user-info-panel-username-input-index-module__input-o_07Nd.\\------packages-foundation-account-ui-base-src-components-user-info-panel-username-input-index-module__error-v8NoHJ {
  border-color: var(--semi-color-danger-light-hover);
}

.\\------packages-foundation-account-ui-base-src-components-user-info-panel-username-input-index-module__input-o_07Nd.\\------packages-foundation-account-ui-base-src-components-user-info-panel-username-input-index-module__error-v8NoHJ .semi-input-prefix {
  background: #ffe0d2;
}

.\\------packages-foundation-account-ui-base-src-components-user-info-panel-username-input-index-module__input-o_07Nd.\\------packages-foundation-account-ui-base-src-components-user-info-panel-username-input-index-module__error-v8NoHJ:focus-within {
  border-color: var(--semi-color-danger) !important;
}

.\\------packages-foundation-account-ui-base-src-components-user-info-panel-username-input-index-module__page-GDfBX3 {
  margin-bottom: 12px;
}

.\\------packages-foundation-account-ui-base-src-components-user-info-panel-username-input-index-module__page-GDfBX3 .semi-input-prefix {
  border-right: 1px solid rgba(29, 28, 35, .16);
}

.\\------packages-foundation-account-ui-base-src-components-user-info-panel-username-input-index-module__page-GDfBX3.\\------packages-foundation-account-ui-base-src-components-user-info-panel-username-input-index-module__error-v8NoHJ .semi-input-prefix {
  border-right-color: rgba(0, 0, 0, 0);
}

.\\------packages-foundation-account-ui-base-src-components-user-info-panel-username-input-index-module__modal-zzCLN1 {
  margin-bottom: 8px;
}

.\\------packages-foundation-account-ui-base-src-components-user-info-panel-username-input-index-module__modal-zzCLN1 .semi-input-prefix {
  border-right: 1px solid rgba(29, 28, 35, .08);
}

.\\------packages-foundation-account-ui-base-src-components-user-info-panel-username-input-index-module__modal-zzCLN1.\\------packages-foundation-account-ui-base-src-components-user-info-panel-username-input-index-module__error-v8NoHJ .semi-input-prefix {
  border-right-color: rgba(0, 0, 0, 0);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"input": `------packages-foundation-account-ui-base-src-components-user-info-panel-username-input-index-module__input-o_07Nd`,
	"page": `------packages-foundation-account-ui-base-src-components-user-info-panel-username-input-index-module__page-GDfBX3`,
	"modal": `------packages-foundation-account-ui-base-src-components-user-info-panel-username-input-index-module__modal-zzCLN1`,
	"error": `------packages-foundation-account-ui-base-src-components-user-info-panel-username-input-index-module__error-v8NoHJ`
};
export default ___CSS_LOADER_EXPORT___;
